export default "__VITE_ASSET__c45f1bac__"